import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Usuario } from './../../models/usuario.model';
import { ApiService } from './../api.service';
import { Injectable } from '@angular/core';
import { daApi, listaDaApi, MAP_USUARIO, ORDEM_USUARIO, paraApi, parametrosLista } from '../api-map';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor(
    public api: ApiService
  ) { }

  get(numeroPagina: number, registroPorPagina: number, ordenacao: string, sentidoOrdenacao: string, filtro?: string): Observable<UsuariosApi> {
    const query = parametrosLista(numeroPagina, registroPorPagina, ordenacao, sentidoOrdenacao, filtro, ORDEM_USUARIO, 'name');

    return this.api.get('/user' + query).pipe(
      map((res: any) => {
        const lista = listaDaApi(res, MAP_USUARIO);
        return { usuarios: lista.itens, numeroPaginas: lista.numeroPaginas } as UsuariosApi;
      })
    );
  }

  getById(id): Observable<any> {
    return this.api.get(`/user/${id}`).pipe(map((res: any) => daApi(res, MAP_USUARIO)));
  }

  getByEmail(email): Observable<any> {
    return this.api.get(`/user?page=1&count=1&filter=${encodeURIComponent(email)}`)
      .pipe(map((res: any) => (res && res.data && res.data[0]) ? daApi(res.data[0], MAP_USUARIO) : null));
  }

  post(user: Usuario): Observable<any> {
    return this.api.post('/user', paraApi(user, MAP_USUARIO));
  }

  patch(user: Usuario): Observable<any> {
    return this.api.patch('/user', paraApi(user, MAP_USUARIO));
  }

  delete(user: Usuario): Observable<any> {
    return this.api.delete(`/user/${user.id}`);
  }

  deleteSelected(users: Usuario[]): Observable<any> {
    return this.api.deleteComCorpo('/user', users.map(u => ({ id: u.id })));
  }

  postFile(file: File, url: string, fileName: string) {
    return this.api.postFile(file, url, fileName);
  }

}

export interface UsuariosApi {
  usuarios: Usuario[];
  numeroPaginas: number;
}
